import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { ICountryObject } from "app/services/CountryService";

import type { IAppListedAddressFilterDto } from "../../types/commonFiltersDto";

export default class FindListedAddressFilter
    extends FilterPanelBaseFilter<IAppListedAddressFilterDto, ICountryObject[]>
    implements IFilterPanelBaseFilterModel<IAppListedAddressFilterDto, ICountryObject[]>
{
    constructor(deps: IFilterPanelBaseFilterDeps<IAppListedAddressFilterDto, ICountryObject[]>) {
        super(deps);
    }

    isFilterDirty(currentValue: IAppListedAddressFilterDto | undefined): boolean {
        return Boolean(currentValue?.countries && currentValue?.countries.length > 0);
    }
}
